module.exports = __webpack_public_path__ + "img/IMG_6258_L_Black_MockedUp.c694c221.jpg";